"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryClient = void 0;
const react_query_1 = require("@tanstack/react-query");
exports.queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            // additionally we want to invalidate data on page changes, so
            // add queryClient.invalidateQueries() to link onclick
            refetchOnMount: false,
        },
    },
});
